import { gql } from '@apollo/client';

export const VEHICLE_DETAILS = gql`
  query getVehicleInfoForWormwood(
    $market: MarketType!
    $lang: String!
    $id: String!
    $version: String
  ) {
    getVehicleInfoForWormwood(market: $market, lang: $lang, id: $id, version: $version) {
      stockNumber
      dealerName
      vehicleType
      isAvailableNow
      kvpsSyncId
      oaddStockNumber
    }
  }
`;

export const GET_FILTERED_VEHICLES = gql`
  query getFilteredVehiclesForWormwood(
    $version: String
    $market: [MarketType]!
    $limit: Int
    $lang: String!
    $filters: String
    $ranges: String
    $sort: String
    $offset: Int
    $preset: String
  ) {
    getFilteredVehiclesForWormwood(
      version: $version
      market: $market
      size: $limit
      lang: $lang
      filters: $filters
      ranges: $ranges
      sort: $sort
      from: $offset
      preset: $preset
    ) {
      filterResults {
        totalCount
      }
      vehicles {
        vin
        id
      }
    }
  }
`;
